import React, { Component } from "react";
import PropTypes from "prop-types";
import QRCode from "qrcode-react";
import { CopyToClipboard } from "react-copy-to-clipboard";

import { Header, Icon, List } from "semantic-ui-react";
import "./VotifySharePartyView.css";

const SharePartyIcon = ({ name, onClick, color, link }) => {
  if (link) {
    return (
      <a href={link}>
        <Icon name={name} size="huge" color={color} />
      </a>
    );
  } else {
    return (
      <span>
        <Icon name={name} onClick={onClick} size="huge" color={color} />
      </span>
    );
  }
};

class VotifySharePartyView extends Component {
  constructor(props) {
    super(props);
    this.state = { hasCopied: false };
    this.handleClickIcon = this.handleClickIcon.bind(this);
    this.handleClickCopy = this.handleClickCopy.bind(this);
  }

  handleClickIcon() {
    console.log("Clicked icon");
  }

  handleClickCopy() {
    console.log("Clicked copy");
    this.setState({ hasCopied: true });
  }

  shareIcons = [
    {
      name: "facebook messenger",
      onClick: this.handleClickIcon,
      color: "blue",
      getLink: (url) => `fb-messenger://share?link=${url}`,
    },
    {
      name: "whatsapp",
      onClick: this.handleClickIcon,
      color: "green",
      getLink: (url) => `whatsapp://send?text=${url}`,
    },
  ];

  render() {
    return (
      <div className="share-party-dialog-dimmer-content-wrapper">
        <div className="share-party-dialog-dimmer-content">
          <Header
            as={"h1"}
            color={"green"}
            onClick={this.props.handleClickHeader}
            content="Spotbox"
          />
          <List horizontal>
            {this.shareIcons.map(({ name, onClick, color, getLink }) => (
              <List.Item key={name}>
                <SharePartyIcon
                  name={name}
                  onClick={onClick}
                  link={getLink ? getLink(this.props.partyUrl) : null}
                  color={color}
                />
              </List.Item>
            ))}
            <List.Item>
              <CopyToClipboard
                text={this.props.partyUrl}
                onCopy={this.handleClickCopy}
              >
                <SharePartyIcon color="grey" name="copy" />
              </CopyToClipboard>
            </List.Item>
          </List>
          <Header
            as="h2"
            style={{ visibility: this.state.hasCopied ? "visible" : "hidden" }}
          >
            Copied!
          </Header>
          <Header color={"grey"} as={"h3"} content={this.props.partyUrl} />
          <QRCode
            size={256}
            bgColor={"rgb(224, 224, 224)"}
            value={this.props.partyUrl}
          />
        </div>
      </div>
    );
  }
}

VotifySharePartyView.propTypes = {
  partyUrl: PropTypes.string.isRequired,
  handleClickHeader: PropTypes.func,
};

export default VotifySharePartyView;
